export default __webpack_public_path__ + "static/media/clipsMenu.0c0af481.svg";